'use client';

import Link from '@/components/NoPrefetchLink';
import type { ReactNode } from 'react';

type EmptyStateLink = {
  href: string;
  label: ReactNode;
  note?: ReactNode;
};

type Props = {
  id: string;
  title: ReactNode;
  paragraphs: ReactNode[];
  links?: EmptyStateLink[];
  linksLabel?: string;
  className?: string;
};

export default function PageEmptyState({
  id,
  title,
  paragraphs,
  links = [],
  linksLabel,
  className,
}: Props) {
  const titleId = `${id}-title`;
  const containerClassName = ['page-empty-state', className].filter(Boolean).join(' ');

  return (
    <section className={containerClassName} aria-labelledby={titleId}>
      <h2 id={titleId}>{title}</h2>
      {paragraphs.map((paragraph, index) => (
        <p key={`${id}-paragraph-${index}`} className="page-empty-copy">
          {paragraph}
        </p>
      ))}
      {links.length > 0 && (
        <div className="page-empty-links" aria-label={linksLabel}>
          {links.map((link) => (
            <Link key={`${id}-${String(link.href)}`} href={link.href} className="page-empty-link">
              <span className="page-empty-link-title">{link.label}</span>
              {link.note && <span className="page-empty-link-note">{link.note}</span>}
            </Link>
          ))}
        </div>
      )}
    </section>
  );
}
